import { render } from "./default-icon.vue?vue&type=template&id=4039e75a&scoped=true"
import script from "./default-icon.vue?vue&type=script&lang=js"
export * from "./default-icon.vue?vue&type=script&lang=js"

import "./default-icon.vue?vue&type=style&index=0&id=4039e75a&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4039e75a"]])

export default __exports__